const WATER_DAMAGES_SOURCES = ['Pipe', 'Appliance', 'Sewer', 'Flood', 'Sump Pump', 'Seepage', 'Unknown'] as const;

export default WATER_DAMAGES_SOURCES;
